import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'translateCut',
  standalone: true,
})
export class TranslateCutPipe implements PipeTransform {
  transform(
    value: string,
    index: number,
    opts: { delimeter?: string; trim?: boolean } = {},
  ): string {
    const { delimeter = '|', trim = false } = opts;
    const parts = value.split(delimeter);
    const str = parts[index] || '';
    return trim ? str.trim() : str;
  }
}
